"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const bew_localization_1 = require("@skype/bew-localization");
const react_1 = require("@stardust-ui/react");
const React = require("react");
const ConfigContext_1 = require("../../contexts/ConfigContext");
const ErrorHelper_1 = require("../../helpers/ErrorHelper");
class ErrorDetails extends React.PureComponent {
    constructor(props) {
        super(props);
    }
    render() {
        const displayableError = ErrorHelper_1.ErrorHelper.isDisplayableError(this.props.error) ?
            this.props.error : ErrorHelper_1.ErrorHelper.convertToGenericDisplayableError(this.props.error);
        return React.createElement("div", { className: 'errorDetails' },
            this.props.showSkype && React.createElement(react_1.Header, { as: 'h1', content: 'Skype', className: 'title' }),
            React.createElement(ConfigContext_1.ConfigContextConsumer, null, (configContext) => displayableError.emoticonPath && React.createElement(react_1.Image, { className: 'logo', src: `${configContext.basePath}${displayableError.emoticonPath}`, "aria-hidden": 'true' })),
            React.createElement(react_1.Header, { as: 'h2', content: bew_localization_1.localizer.getString(displayableError.headerLocString), className: 'title' }),
            React.createElement(react_1.Text, { size: 'medium', className: 'description' }, bew_localization_1.localizer.getString(displayableError.descriptionLocString)));
    }
}
exports.ErrorDetails = ErrorDetails;
